import { User } from "@CommonApi/auth/login";
import { decodeJwtPayload } from "src/utils/jwt";
import { pages } from "src/utils/pages";

export type AuthTabSyncAction = "none" | "reload" | "login";

type TabUser = Pick<User, "id" | "merchantId">;

const getTokenUser = (token: string): TabUser | null => {
  try {
    return (decodeJwtPayload(token) as { user: TabUser }).user;
  } catch {
    return null;
  }
};

// Compares user and merchant rather than the raw token, which TokenRenewer rewrites every 30 minutes.
export const getAuthTabSyncAction = (
  tabUser: TabUser | null,
  newToken: string | null,
): AuthTabSyncAction => {
  if (!tabUser) {
    return "none";
  }

  if (!newToken) {
    return "login";
  }

  const tokenUser = getTokenUser(newToken);
  if (tokenUser?.id === tabUser.id && tokenUser.merchantId === tabUser.merchantId) {
    return "none";
  }

  return "reload";
};

export const applyAuthTabSyncAction = (action: AuthTabSyncAction) => {
  if (action === "login") {
    window.location.href = pages.login;
  } else if (action === "reload") {
    window.location.reload();
  }
};
